<template>
  <AppClientSimpleLayout>
    <div class="flex flex-col items-center justify-center min-h-screen bg-white">
      <h1 class="text-4xl md:text-5xl font-bold mb-12 md:my-12 text-center">料金プラン</h1>
      <div class="flex flex-col w-full max-w-6xl px-4 md:px-8">
        <div class="flex flex-col md:flex-row gap-8 justify-center items-center flex-grow">
          <!-- 月額プラン -->
          <button
            @click="subscriptionMonthly()"
            class="border-2 border-CLIENT_PRIMARY_PINK rounded-2xl mx-12 py-10 text-center bg-white shadow-md transition-all duration-300 hover:scale-105 cursor-pointer w-full md:w-80 relative"
          >
            <div class="text-3xl font-bold mb-4">単月払い</div>
            <div class="text-2xl font-semibold mb-5">4,980<span class="text-sm">円</span><span class="text-base text-gray-600"> / 月</span></div>
            <div class="absolute left-1/2 -translate-x-1/2 bottom-1">
              <span class="text-xs font-semibold text-center whitespace-nowrap px-1">※ワーク＆問題集のプレゼントはございません。</span>
            </div>
          </button>
          <!-- 年額プラン -->
          <button
            @click="subscriptionYearly()"
            class="border-2 border-CLIENT_PRIMARY_PINK rounded-2xl mx-12 pt-10 text-center bg-CLIENT_PRIMARY_PINK text-white shadow-md transition-all duration-300 hover:scale-105 hover:bg-CLIENT_PRIMARY_PINK_HOVER cursor-pointer w-full md:w-80 relative"
          >
            <div class="text-3xl font-bold mb-4">まとめて払い</div>
            <div class="text-2xl font-semibold mb-6">35,856<span class="text-sm">円</span><span class="text-base text-white/80"> / 年</span></div>
            <div class="flex flex-col gap-2 mt-4 pb-1 px-3">
              <span class="text-white text-sm font-semibold text-center whitespace-nowrap">単月あたり3,984円</span>
              <span class="text-white text-xs font-semibold text-center whitespace-nowrap">※お申し込み後、ワーク&問題集を郵送いたします。</span>
            </div>
          </button>
        </div>
          <p class="text-center mt-14 font-bold">⚠️お申し込み後、登録メールアドレスに届くご案内を必ずご確認ください。</p>
        <div class="mt-20 md:mt-40 md:pl-8">
          <button
            class="py-2 px-4 rounded-md font-iroha text-CLIENT_PRIMARY_PINK"
            @click="onClickedBack">
            ＜戻る
          </button>
        </div>
      </div>
    </div>
  </AppClientSimpleLayout>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import AppClientSimpleLayout from '@/Layouts/AppClientSimpleLayout'

const onClickedBack = () => {
  Inertia.get(route('portal.index'))
}

//月額プラン
const subscriptionMonthly = () => {
  Inertia.post(route('client.subscription', {
    price_id: process.env.MIX_STRIPE_TERAKOYA_MONTHLY_PRICE_ID,
  }))
}
//年額プラン
const subscriptionYearly = () => {
  Inertia.post(route('client.subscription', {
    price_id: process.env.MIX_STRIPE_TERAKOYA_YEARLY_PRICE_ID,
  }))
}
</script>

<style scoped>
/* 必要なスタイルのみを残す */
.hover-parent:hover .hover-child {
  background-color: #d1d5db;
}
</style>
